<template>
  <div class="home">home page</div>
</template>

<script>
export default {
  name: 'Home'
}
</script>
